<br><br><br><br>
<div class="page-title">
  <mat-icon class="app-icon">quick_reference_all</mat-icon>
  <h1 class="title-text">Field Book Number Look-Up</h1>
  <p class="form-desc">Please enter any part of the 'Requestor Email', the 'Office Reporting To' or a start or end date, below. Upon submitting, the table will populate
  with field book assignments that match the search parameters.</p>
</div>
<br>

  <mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
          <mat-label>Requestor Email</mat-label>
          <input matInput formControlName="requestorEmail" placeholder="Enter any part of the requestor email (optional)">
        </mat-form-field>

        <!-- Office Reporting To -->
        <mat-form-field appearance="fill">
          <mat-label>Office Reporting To</mat-label>
          <mat-select formControlName="office">
            <mat-option value="houston">Houston</mat-option>
            <mat-option value="ftworth">Ft. Worth</mat-option>
            <mat-option value="austin">Austin</mat-option>
            <mat-option value="irving">Irving</mat-option>
            <mat-option value="frisco">Frisco</mat-option>
            <mat-option value="bossiercity">Bossier City</mat-option>
            <mat-option value="magnolia">Magnolia</mat-option>
            <mat-option value="windsor">Windsor</mat-option>
            <mat-option value="midland">Midland</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Date -->
        <mat-form-field appearance="fill">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <div class="submit-button">
          <button mat-raised-button color="primary" type="submit">Search</button>
          <button mat-raised-button type="button" (click)="refreshData()">Reset Form</button>
        </div>

        @if (isLoading) {
          <div class="custom-spinner-container">
            <div class="custom-spinner"></div>
          </div>
        }

      </form>
    </mat-card-content>
  </mat-card>

@if (searchConducted && !isLoading) {
  <br>
    <div class="table-header">
      <div class="links-title">Field Book Number Assignments:</div>
    </div>
    <div class="table-group">
      @if (dataSource.data.length > 0) {
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="officeName">
            <th mat-header-cell *matHeaderCellDef>Office</th>
            <td mat-cell *matCellDef="let element">{{ commonFunctionsService.translateOfficeLabelReverse(element.officeName) }}</td>
          </ng-container>

          <ng-container matColumnDef="requestorEmail">
            <th mat-header-cell *matHeaderCellDef>Requestor</th>
            <td mat-cell *matCellDef="let element">{{ element.requestorEmail }}</td>
          </ng-container>

          <ng-container matColumnDef="dateAssigned">
            <th mat-header-cell *matHeaderCellDef>Date Assigned</th>
            <td mat-cell *matCellDef="let element">{{ element.dateAssigned | date:'short' }}</td>
          </ng-container>

          <ng-container matColumnDef="fieldBookNumber">
            <th mat-header-cell *matHeaderCellDef>Field Book Number</th>
            <td mat-cell *matCellDef="let element">{{ element.fieldBookNumber }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <br>
        <div class="total-results">
          Total Log Entries: {{ dataSource.data.length }}
        </div>
      } @else {
        <div class="no-data">
          No data found for the selected criteria.
        </div>
      }
    </div>

}
